import SecuritySection from './security-section-view'
export default SecuritySection
